import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { isAfter } from 'date-fns';
// Client side validators
export function dateValueIsAfterOrBeforeOtherControl(otherDateControlId: string, shouldBeAfterOtherDateValue: boolean): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (control.value && !isNaN(control.value.getTime()) && control.parent) {
      const otherDateControl = control.parent.get(otherDateControlId);
      if (otherDateControl.value) {
        const isControlValueAfterOther = isAfter(control.value, otherDateControl.value);
        if (isControlValueAfterOther) {
          if (shouldBeAfterOtherDateValue) {
            if (!otherDateControl.valid) {
              otherDateControl.updateValueAndValidity();
            }
            return null;
          } else {
            return { 'invalidDate': { value: control.value } };
          }
        } else {
          if (shouldBeAfterOtherDateValue) {
            return { 'invalidDate': { value: control.value } };
          } else {
            if (!otherDateControl.valid) {
              otherDateControl.updateValueAndValidity();
            }
            return null;
          }
        }
      } else {
        return null;
      }
    } else {
      return null;
    }
  };
}
